import { createFeature, createReducer, on } from '@ngrx/store';
import {
  loadMonitoringMetrics,
  loadMonitoringMetricsDataSuccess,
  setAllChartShowing,
  setMonitoringMetricPreference,
  setMonitoringPeriod,
  setSearchValue,
} from '../actions';
import {
  MonitoringChartData,
  MonitoringMetricsSeriesDataType,
  MonitroingMetricPreferencies,
} from '@app/monitoring/common/monitoring-metrics.types';
import { EntityAdapter, EntityState, createEntityAdapter } from '@ngrx/entity';
import { MonitoringChartPeriod, MonitoringChartType } from '@app/monitoring/monitoring.constants';
import { environment } from 'src/environments/environment';
import { searchMetric } from '../monitoring-metrics.helpers';

const { metrixСolors } = environment;

export const monitoringChartDataAdapter: EntityAdapter<MonitoringChartData> = createEntityAdapter<MonitoringChartData>({
  selectId(value: MonitoringChartData): string {
    return value.code;
  },
  sortComparer: false,
});

export interface IMonitoringMetricsState extends EntityState<MonitoringChartData> {
  searchValue: string | null;
  // NOTE: перечень категорий для шкалы "xAxis.data"
  categories: string[];
  ids: string[];
  chartPreferencies: Record<string, MonitroingMetricPreferencies>;
  currencyMultiplication: string;
  currency: string;
  period: MonitoringChartPeriod;
}

const initMonitoringMetricsState: IMonitoringMetricsState = monitoringChartDataAdapter.getInitialState({
  searchValue: '',
  categories: [],
  ids: [],
  chartPreferencies: {},
  currencyMultiplication: '',
  currency: '',
  period: MonitoringChartPeriod.Month,
});

export const monitoringMetricsFeature = createFeature({
  name: 'monitoringMetrics',
  reducer: createReducer(
    initMonitoringMetricsState,
    // NOTE: получение данных из внешнего источника
    on(loadMonitoringMetrics, (state, payload) => {
      return monitoringChartDataAdapter.removeAll({ ...state });
    }),
    on(loadMonitoringMetricsDataSuccess, (state, payload) => {
      const newChartPreferencies: Record<string, MonitroingMetricPreferencies> = payload.series
        .filter((item) => !state.chartPreferencies[item.code])
        .reduce((acc: Record<string, MonitroingMetricPreferencies>, item) => {
          const preferencies: MonitroingMetricPreferencies = {
            chartType: MonitoringChartType.Line,
            chartShowing: true,
            chartColor: metrixСolors[item.code] || metrixСolors['default'],
          };
          acc[item.code] = preferencies;
          return acc;
        }, {});

      return monitoringChartDataAdapter.setAll(payload.series, {
        ...state,
        categories: payload.category,
        currencyMultiplication: payload.currency_multiplication.toLowerCase(),
        currency: payload.currency.toLowerCase(),
        chartPreferencies: { ...state.chartPreferencies, ...newChartPreferencies },
      });
    }),
    on(setSearchValue, (state, { payload }) => {
      return { ...state, searchValue: payload.value };
    }),
    on(setMonitoringMetricPreference, (state, { payload }) => {
      return {
        ...state,
        chartPreferencies: {
          ...state.chartPreferencies,
          [payload.id]: payload.preferencies,
        },
      };
    }),
    on(setMonitoringPeriod, (state, { payload }) => {
      return {
        ...state,
        period: payload.value,
      };
    }),
    on(setAllChartShowing, (state: IMonitoringMetricsState, { payload }) => {
      console.log('state.entities', state.ids, state.searchValue);
      const chartPreferencies = state.ids.reduce(
        (acc: Record<string, MonitroingMetricPreferencies>, code) => {
          console.table(code);
          if (state.entities[code] && searchMetric(state.entities[code]!, state.searchValue)) {
            const preferencies: MonitroingMetricPreferencies = {
              chartType: MonitoringChartType.Line,
              chartShowing: true,
              chartColor: metrixСolors[code] || metrixСolors['default'],
            };
            acc[code] = { ...preferencies, ...state.chartPreferencies[code], chartShowing: payload };
          }
          return acc;
        },
        { ...state.chartPreferencies },
      );
      return {
        ...state,
        chartPreferencies: {
          ...chartPreferencies,
        },
      };
    }),
  ),
});
